export default "__VITE_ASSET__ChmSff3F__"